import { Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from '@spartacus/core';
import { ProductListOutlets } from '@spartacus/storefront';
import { CheckAvailabilityDialogComponent } from '../check-availability-dialog/check-availability-dialog.component';
import { isPlatformBrowser } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-kb-cross-ref-list-item',
  templateUrl: './kb-cross-ref-list-item.component.html',
  styleUrls: ['./kb-cross-ref-list-item.component.scss'],
  standalone: false
})
export class KbCrossRefComponent {

  @Input() product: any;
  @Input() searchQuery: any;
  readonly ProductListOutlets = ProductListOutlets;
  isLoggedIn: boolean = false;
  distributerType: string;
  platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  constructor(public authService: AuthService, private dialog: MatDialog) {
    this.authService
      .isUserLoggedIn().pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;

      })
    if (isPlatformBrowser(this.platformId)) {
      this.distributerType = document.cookie.split(";")[1]?.split("=")[1]?.split("_")[2];
    }
  }

  checkAvailability(productCode) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'check-availability-popup';
    dialogConfig.data = { productCode, page: 'PLP' };
    const dialogRef = this.dialog.open(CheckAvailabilityDialogComponent, dialogConfig);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
